import { ICustomerAccount } from 'app/shared/model/customer-account.model';
import { IAddress } from 'app/shared/model/address.model';
import { IContact } from 'app/shared/model/contact.model';
import { OrganizationType } from 'app/shared/model/enumerations/organization-type.model';
import { EnterpriseSize } from 'app/shared/model/enumerations/enterprise-size.model';

export interface IOrganisation {
  id?: number;
  organisationId?: string | null;
  name?: string | null;
  vatId?: string | null;
  organizationType?: keyof typeof OrganizationType | null;
  status?: boolean | null;
  enterpriseSize?: keyof typeof EnterpriseSize | null;
  customerAccount?: ICustomerAccount | null;
  parentOrganisation?: IOrganisation | null;
  organisationAddress?: IAddress | null;
  contact?: IContact | null;
}

export const defaultValue: Readonly<IOrganisation> = {
  status: false,
};
